import styled from 'styled-components'

export const ListNoBullets = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 20px;
`
